import React from 'react'

const Manual_acciones_individuales_clientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Acciones individuales para clientes
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Conoce cómo aplicar acciones individuales a clientes específicos dentro del Dashboard de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Acciones_individuales_para_clientes__wxicYGL0T5KI6Ongqjk1wQ?as=scrollable"
          className="scribe-iframe-general-89"
          width="100%"
          height="6000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_acciones_individuales_clientes
